import { render, staticRenderFns } from "./StockBrandEanList.vue?vue&type=template&id=8fae4892&scoped=true&"
import script from "./StockBrandEanList.vue?vue&type=script&lang=js&"
export * from "./StockBrandEanList.vue?vue&type=script&lang=js&"
import style0 from "./StockBrandEanList.vue?vue&type=style&index=0&id=8fae4892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fae4892",
  null
  
)

export default component.exports